import apiFetch from '@wordpress/api-fetch';
import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { RegisteredCard } from '../../Types/Mangopay';
import AddCard from './AddCard';

const CardList = ( props ) => {
    let cards: RegisteredCard[] = props?.cards, selected: string = props?.selected, setSelectedCard: (value: string ) => void = props?.setSelectedCard;
    // @ts-ignore
    const { RadioControl, Button } = window.wc.blocksComponents;

    const [allCards, setAllCards] = useState([]);
    const [addingNew, setAddingNew] = useState<boolean>(false);

    useEffect(() => {
        if ( Array.isArray( cards ) && cards.length ) {
            let tempCards = cards.map( item => {
                return {
                    label: <>
                        {item.Alias}
                        &nbsp;
                        <div className="dashicons dashicons-trash" onClick={()=>props.deleteCard(item.Id)}></div>
                    </>,
                    value: item.Id
                }
            } );

            setAllCards( tempCards );
        }
    }, []);

    return(
        <div className='dokan-mangopay-registered-cards-box'>
            {Array.isArray( cards ) && cards.length ?
                <RadioControl
                    className=''
                    onChange={ ( value: string ) => {
                        setSelectedCard(value);
                    } }
                    disabled={ false }
                    selected={ selected }
                    options={ allCards }
                />
                :
                <div className='dokan-mangopay-registered-cards-box-empty'>
                    <p className='dokan-mangopay-registered-cards-box-empty-message'>{__('You have not registered a card yet. You can add one below.', 'dokan')}</p>
                </div>
            }

            <div className='dokan-mangopay-add-new-box'>
                {
                    addingNew ?
                        <AddCard refreshCards={()=>props.refreshCards()} onClose={()=>setAddingNew(false)}/>
                        :
                        <Button onClick={()=>setAddingNew( !addingNew )}>{__( '+ Add New', 'dokan' )}</Button>
                }
            </div>
        </div>
    );
}

export default CardList;
